import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH',
    'FETCH_SUCCESS',
    'FETCH_CALLOUTS',
    'FETCH_CALLOUTS_SUCCESS',
    'FETCH_ACTIVE_CHANNELS',
    'FETCH_ACTIVE_CHANNELS_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'CAMPAIGN');


// Action Creators
export const fetchCampaign = createAction(actions.FETCH, params => params);
export const campaignFetched = createAction(actions.FETCH_SUCCESS, data => data);
export const fetchCampaignCallouts = createAction(actions.FETCH_CALLOUTS, params => params);
export const campaignCalloutsFetched = createAction(actions.FETCH_CALLOUTS_SUCCESS, data => data);
export const fetchActiveChannels = createAction(actions.FETCH_ACTIVE_CHANNELS, params => params);
export const activeChannelsFetched = createAction(actions.FETCH_ACTIVE_CHANNELS_SUCCESS, data => data);
export const resetCampaignInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialState = {
    data: null,
    callouts: null,
    apiConfig: null,
    xAxisLabel: null,
    statistics: null,
    categories: null,
    activeChannels: {},
    hasData: null // defaulting to null to indicate we are fetching data and don't know if we have data or not.
};

export default handleActions({

    [actions.FETCH_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const rootState = action.getState();
            const scopeKey = action.payload.categories.config.selector;

            const updatedData = {
                data: { $set: action.payload[scopeKey] },
                statistics: { $set: action.payload.statistics },
                categories: { $set: action.payload.categories[scopeKey] },
                xAxisLabel: { $set: action.payload.categories.config.xAxisLabel },
                apiConfig: { $set: rootState.config.selectedTimeRange.apiConfig },
                hasData: { $set: hasData }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            hasData: { $set: hasData }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ACTIVE_CHANNELS_SUCCESS]: (state, action) => {
        const updatedData = {
            activeChannels: action.payload
        };
        return update(state, { $merge: updatedData });
    },

    [actions.FETCH_CALLOUTS_SUCCESS]: (state, action) => {
        const updatedData = {
            callouts: action.payload
        };
        return update(state, { $merge: updatedData });
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/campaign/duck.js